import {applyMiddleware, compose, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from './reducer';

function configureStore (initialState) {
    const enhancer = compose(
        applyMiddleware(
            thunkMiddleware,
        )
    );
    return createStore(reducer, initialState, enhancer);
}
const store = configureStore({});
export default store;
